// src/authConfig.js
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AD_CLIENT_ID,
    tenantId: process.env.REACT_APP_AD_TENANT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AD_DOMAIN}`,
    redirectUri: `${process.env.PUBLIC_URL}/`,
  },
  cache: {
    cacheLocation: "localStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: true, // Set to true if you are having issues on IE11 or Edge
  },
};

export const loginRequest = {
  scopes: ["User.Read"], // Add other scopes as needed
};

export const tokenRequest = {
  scopes: ["User.Read", "offline_access"], // offline_access scope is needed for refresh tokens
};
